/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from "axios";
import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class MunicipalityRequest extends MainRequest{

    static addMunicipality(data, token){
        return this.postSEC(ServicePath.MUNICIPALITY_ADD, data)
    }

    static listAllMunicipality(data, token){
        return this.postSEC(ServicePath.MUNICIPALITY_LIST_ALL, data)
    }

    static updateMunicipality(data, token){
        return this.postSEC(ServicePath.MUNICIPALITY_UPDATE, data)
    }

    static deleteMunicipality(data, token){
        return axios.delete(ServicePath.MUNICIPALITY_DELETE, data, token)
    }

}